

































/**
 * @author wangyingxu1
 * 集团教研平台左侧菜单栏
 */

import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import HeaderNav from './headerNav.vue';
import MenuNav from './menuNav.vue';
import BlueMenu from '../blueMenu/index.vue';
import { setDomainUrl } from '@/config';

@Component({
  components: {
    BlueMenu,
    'header-nav': HeaderNav,
    'menu-nav': MenuNav
  }
})
export default class Menu extends Vue {
  @Prop({ type: Array, default: (): any[] => ([]) }) public authTree!: any[];
  @Prop({ type: String, default: '' }) public authUrl?: '';
  @Prop({ type: String, default: '' }) public activeIndex?: string ;
  @Prop({ type: Boolean, default: true }) public showMenu?: boolean;
  @Prop({ type: Boolean, default: true }) public showHeader?: boolean;
  @Prop({ type: [String, Number], default: '' }) public defaultSubjectCode?: string | number;
  @Prop({ type: String, default: 'green' }) public typeColor?: string ;

  public created(): void {
    if (this.authUrl) {
      setDomainUrl('base', this.authUrl);
    }
  }

  @Emit('subject-change')
  public subjectChange(subjectCode: string | number) {
    return subjectCode;
  }
  @Emit('router-change')
  public routerChange(url: string) {
    return url;
  }
}

